import React from 'react';
import { useRouter } from 'next/router';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { MpdComparison, useSegment } from '@sparknz/journeys-common';

import { MpdChangePlanComparisonQuery } from '__generated__/MpdChangePlanComparisonQuery.graphql';
import { useProductDetails } from 'journey/productDetails/provider';
import { extractFirstValue } from 'shared/utils';

const changePlanMpdComparisonQuery = graphql`
  query MpdChangePlanComparisonQuery(
    $channel: CartChannel!
    $lineNumber: String!
    $addOffer: String!
  ) {
    changePlanMpdComparison(
      channel: $channel
      lineNumber: $lineNumber
      addOffer: $addOffer
    ) {
      cartId
      bundles {
        lineNumber
        id
        items {
          productOfferingId
          name
          action
          price {
            priceType
            period
            basePrice
            effectivePrice
            discount {
              discountType
              appliedValue
            }
          }
        }
      }
      existingPlans {
        lineNumber
        productOfferingId
        name
        currentPrice {
          priceType
          period
          basePrice
          effectivePrice
          discount {
            discountType
            appliedValue
          }
        }
        updatedPrice {
          priceType
          period
          basePrice
          effectivePrice
          discount {
            discountType
            appliedValue
          }
        }
      }
      discountPercentageChanged
    }
  }
`;

const MpdChangePlanComparison = () => {
  const { channel } = useSegment();
  const router = useRouter();
  const planId = extractFirstValue(router.query.planId);
  const {
    ifpEligibility: { selectedLineNumber },
  } = useProductDetails();
  const { changePlanMpdComparison } =
    useLazyLoadQuery<MpdChangePlanComparisonQuery>(
      changePlanMpdComparisonQuery,
      { channel, addOffer: planId, lineNumber: selectedLineNumber },
    );
  return (
    <MpdComparison
      lineNumber={selectedLineNumber}
      plansMpdComparison={changePlanMpdComparison}
    />
  );
};

export default MpdChangePlanComparison;
